import { put, takeLatest } from "redux-saga/effects";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  Permission: "[Permission] Action",
  storageData: "[Storage] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  permission: undefined,
  storageData: undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "v713-demo1-auth",
    whitelist: ["user", "authToken", "permission", "storageData"],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }
      case actionTypes.Permission: {
        const { permission } = action.payload;
        return { ...state, permission };
      }
      case actionTypes.storageData: {
        return { ...state, storageData: action.payload.storageData };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  permission: (permission) => ({
    type: actionTypes.Permission,
    payload: { permission },
  }),
  storageData: (storageData) => ({
    type: actionTypes.storageData,
    payload: { storageData },
  }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {});
}
